import React from 'react'
import { motion } from "framer-motion";
// import dthIcon from '../assets/dth.png'
// import mobIcon from '../assets/mobile.png'
// import reIcon from '../assets/recharge.png'
// import gasIcon from '../assets/gas.png'
// import waterIcon from '../assets/water.png'
// import boadbandIcon from '../assets/broadband.png'
import HouseIcon from '@mui/icons-material/House';
import SchoolIcon from '@mui/icons-material/School';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';


export default function Loanpurpose() {
    const purposeList = [
        {
            icon: <HouseIcon style={{fontSize:'50px'}}/>,
            title: "House Rent",
            altdata:"House Rent"
        },
        {
            icon: <SchoolIcon style={{fontSize:'50px'}}/>,
            title: "School Fees",
            altdata:"School Fees"
        },
        {
            icon: <MedicalServicesIcon style={{fontSize:'50px'}}/>,
            title: "Medical Bills",
            altdata:"Medical Bills"
        },
        {
             icon: <CreditCardIcon style={{fontSize:'50px'}}/>,
            title: "Credit Card Payment",
            altdata:"Credit Card Payment"
        },
        {
             icon: <AirplanemodeActiveIcon style={{fontSize:'50px'}}/>,
            title: "Travel Bookings",
            altdata:"Travel Bookings"
        },
        {
            icon: <CurrencyRupeeIcon style={{fontSize:'50px'}}/>,
            title: "Utility Bills",
            altdata:"Utility Bills"
        },
    ];
    return (
        <section className="relative bg-gradient-to-r from-[#011F41] to-[#011F41] py-16 px-4 overflow-hidden">

            {/* Background Glow */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-500/20 blur-3xl rounded-full"></div>
            <div className="max-w-7xl mx-auto relative z-10">
                <p className='ms-text-secondary uppercase font-semibold text-lg mb-2'>Use case</p>
                <h4 className='text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-snug'>Common Financial Needs Before Personal Loan</h4>
                <p className='py-2  text-gray-300 text-sm sm:text-base leading-8'>Short-term financial support for planned and urgent expenses.</p>
                  {/* Cards */}
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-6 gap-6 pt-5">

                    {purposeList.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="group rounded-lg py-3 text-center
                 border border-white/60
                hover:bg-white/20 hover:scale-105 transition-all duration-300 shadow-lg"
                        >
                            <div className="flex justify-center mb-4 text-cyan-400 group-hover:text-white transition">
                               {/* <img src={item.icon} alt={item.altdata}  height={30}/> */}
                               {item.icon}
                            </div>

                            <h3 className="text-white font-medium text-ms">
                                {item.title}
                            </h3>
                        </motion.div>
                    ))}

                </div>
            </div>
        </section>
    )
}
